var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "campaigns-list" },
    [
      _c("div", { staticClass: "header" }, [
        _c("div", { staticClass: "title-block" }, [
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("metaInsights.campaigns"))),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "subtitle" }, [
            _vm._v(_vm._s(_vm.$t("metaInsights.campaignsDesc"))),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "toolbar" },
          [
            _c("DateRangePicker", {
              on: { change: _vm.loadCampaigns },
              model: {
                value: _vm.dateRange,
                callback: function ($$v) {
                  _vm.dateRange = $$v
                },
                expression: "dateRange",
              },
            }),
            _vm._v(" "),
            _c(
              "SupsisButton",
              {
                attrs: { ghost: "", disabled: _vm.loading },
                on: { click: _vm.loadCampaigns },
              },
              [
                _c(
                  "i",
                  {
                    staticClass: "material-icons",
                    class: { spinning: _vm.loading },
                  },
                  [_vm._v("refresh")]
                ),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("metaInsights.refresh")) +
                    "\n            "
                ),
              ]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "a-spin",
        { attrs: { spinning: _vm.loading } },
        [
          _c("InsightsTable", {
            attrs: {
              rows: _vm.campaigns,
              currency: _vm.currency,
              "table-id": "meta-insights-campaigns-table",
              "name-label-key": "metaInsights.col.campaign",
              clickable: true,
            },
            on: { "row-click": _vm.onRowClick },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.hasMore
        ? _c(
            "div",
            { staticClass: "load-more-wrap" },
            [
              _c(
                "SupsisButton",
                {
                  attrs: { ghost: "", disabled: _vm.loadingMore },
                  on: { click: _vm.loadMore },
                },
                [
                  _vm.loadingMore
                    ? _c("i", { staticClass: "material-icons spinning" }, [
                        _vm._v("refresh"),
                      ])
                    : _c("i", { staticClass: "material-icons" }, [
                        _vm._v("expand_more"),
                      ]),
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.loadingMore
                          ? _vm.$t("metaInsights.loading")
                          : _vm.$t("metaInsights.loadMore")
                      ) +
                      "\n        "
                  ),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }